/* eslint-disable */
//Ajax-JSON函数
//强制为同步模式
import { Dialog, Toast } from "vant";
import $fn from "./fn";
import { connectWebViewJavascriptBridge } from "./bridgeApp";
import { createBoxAuthorizationFromRequest } from "./box-auth";
import httpApi from "../apis/httpApi";
const TYPE = ["/v1/newLog"];
const LEGACY_SIGN_KEYS = ["rqtime", "rqrandom", "sign"];
import { toSign } from "./HmacSHA";

function stripLegacySignFields(data) {
  if (!data || typeof data !== "object") {
    return data;
  }
  const result = {};
  Object.keys(data).forEach((key) => {
    if (LEGACY_SIGN_KEYS.indexOf(key) === -1) {
      result[key] = data[key];
    }
  });
  return result;
}

function AjaxJson(url, method, args, fn, dataType) {
  var obj = null;
  var ajax = new AjaxObject();
  ajax.URL = url;
  ajax.dataType = dataType;
  ajax.Method = method;
  ajax.Async = true;
  ajax.Args = args;
  ajax.onSuccess = function(xhr) {
    var text = xhr.responseText;
    if (text.charCodeAt() == 65279) text = text.substring(1); //处理utf8引导字节
    eval("obj=" + text);
    fn(obj, xhr);
    if (
      (obj.code && (obj.code == 400 || obj.code == 50008)) ||
      obj.code === 401
    ) {
      Dialog.alert({
        message: obj.msg,
      }).then(() => {
        connectWebViewJavascriptBridge(7, "1");
      });
    } else if (obj.code !== 200) {
      Toast(obj.msg);
    }
  };
  ajax.onFailure = function(xhr) {
    eval("obj={Tag:'ERROR',Status:'" + xhr.status + "'}");
    fn(obj);
  };
  ajax.Connect();
  return obj;
}

//Ajax标准类模块
function AjaxObject() {
  let version = "";
  if (sessionStorage.getItem("appv")) {
    version = sessionStorage.getItem("appv");
  }
  const strVersion = version.replace(/&.+/, "");
  let numVersion = strVersion.replace(/[^0-9]/g, "");
  const mainVersion = numVersion.slice(0, 3);
  const isVersion = Number(mainVersion) >= 350;
  const DEVICE = sessionStorage.getItem("device") || $fn.mobile();
  let VERSION = sessionStorage.getItem("appv")
    ? sessionStorage.getItem("appv")
    : "";
  const DEVICEID = sessionStorage.getItem("deviceId")
    ? sessionStorage.getItem("deviceId")
    : "";
  const signParams = {
    appv: VERSION,
    device: DEVICE,
    deviceId: DEVICEID,
  };
  if (DEVICE == "ios") {
    if (mainVersion >= 371) {
      signParams.isEmbedded = true;
      signParams.embedded = "web";
    }
  } else {
    if (mainVersion >= 382) {
      signParams.isEmbedded = true;
      signParams.embedded = "web";
    }
  }
  this.URL = "";
  this.Method = "GET";
  this.Async = true;
  this.Args = null;
  this.onSuccess = function() {};
  this.onFailure = function() {};
  this.Request = window.XMLHttpRequest
    ? new XMLHttpRequest()
    : new ActiveXObject("Microsoft.XMLHTTP");

  if (!AjaxObject.requestInterceptors) {
    AjaxObject.requestInterceptors = [];
  }

  AjaxObject.useRequestInterceptor = function(interceptor) {
    this.requestInterceptors.push(interceptor);
  };
  // 执行拦截器链
  this.runInterceptors = async function(config) {
    for (let interceptor of AjaxObject.requestInterceptors) {
      config = await interceptor(config);
    }
    return config;
  };

  this.Connect = function() {
    this.Method = this.Method.toUpperCase();
    // 请求拦截器参数
    const config = {
      url: this.URL,
      method: this.Method,
      args: this.Args,
      dataType: this.dataType,
      headers: {},
    };
    this.runInterceptors(config).then(async (finalConfig) => {
      const requestConfig = {
        ...config,
        ...finalConfig,
        headers: {
          ...(config.headers || {}),
          ...((finalConfig && finalConfig.headers) || {}),
        },
      };
      this.URL = requestConfig.url;
      this.Method = String(requestConfig.method || this.Method).toUpperCase();
      this.Args = requestConfig.args;
      this.dataType = requestConfig.dataType;
      const signObj = {
        deviceType: DEVICE, //设备类型
        deviceId: DEVICEID,
        appv: VERSION,
        token: sessionStorage.getItem("token") || "",
      };
      const hasBoxAuth = $fn.getBoxVersion() >= 501;
      let boxAuthData = {};
      let boxAuthRequestConfig = requestConfig;

      if (this.Method == "GET") {
        this.Request.open(this.Method, this.URL, this.Async);
        if (this.dataType == "json") {
          this.Request.setRequestHeader(
            "Content-type",
            "application/json;charset=UTF-8",
          );
        } else {
          this.Request.setRequestHeader(
            "Content-type",
            "application/x-www-form-urlencoded;",
          );
        }
        var args = "";

        if (this.URL.indexOf("/Gameindex/getBlackWords") > 0) {
          this.Args = "";
        }
        this.Args = this.Args ? this.Args : {};
        if (typeof this.Args == "object") {
          // 增加sign验签参数
          this.Args = hasBoxAuth
            ? stripLegacySignFields(this.Args)
            : $fn.toSign(this.Args, isVersion ? signParams : undefined);
          requestConfig.params = { ...this.Args };
          boxAuthData = { ...requestConfig.params };
          boxAuthRequestConfig = {
            ...requestConfig,
            params: boxAuthData,
          };
          var arr = new Array();
          for (var k in this.Args) {
            var v = this.Args[k];
            arr.push(k + "=" + v);
          }
          args = arr.join("&");
          if (args) {
            this.URL += (this.URL.indexOf("?") == -1 ? "?" : "&") + args;
          }
          this.Args = null;
        }

      }
      var q = this.Request;
      var evt1 = this.onSuccess;
      var evt2 = this.onFailure;
      var evt3 = this.onLoadend;
      this.Request.onreadystatechange = function() {
        _onStateChange(q, evt1, evt2, evt3);
      };
      this.Request.open(this.Method, this.URL, this.Async);
      this.Request.setRequestHeader("device", DEVICE);
      this.Request.setRequestHeader("appv", VERSION);
      this.Request.setRequestHeader("token", sessionStorage.getItem("token"));
      this.Request.setRequestHeader("deviceId", DEVICEID);
      this.Request.setRequestHeader(
        "box-agent",
        $fn.headerBoxAgent(signParams),
      );
      // if(DEVICE == "ios") {
      //   if($fn.getBoxVersion >= 370) {

      //   }
      // }

      if (this.Method == "POST") {
        if (this.dataType == "json") {
          this.Request.setRequestHeader(
            "Content-type",
            "application/json;charset=UTF-8",
          );
        } else {
          this.Request.setRequestHeader(
            "Content-type",
            "application/x-www-form-urlencoded;",
          );
        }
        let args = "";
        // 增加sign验签参数
        const typeSign = this.URL.indexOf(TYPE) !== -1;
        this.Args = this.Args ? this.Args : {};
        if (hasBoxAuth) {
          this.Args = stripLegacySignFields(this.Args);
        } else if (typeSign) {
          this.Args = toSign(this.Args);
        } else {
          this.Args = $fn.toSign(this.Args, isVersion ? signParams : undefined);
        }
        boxAuthData = this.Args;
        if (typeof this.Args == "string") {
          args = this.Args;
        } else if (typeof this.Args == "object") {
          if (this.dataType == "json") {
            this.Args = JSON.stringify(this.Args);
          } else {
            let arr = new Array();
            for (let k in this.Args) {
              let v = this.Args[k];
              arr.push(k + "=" + v);
            }
            args = arr.join("&");
            this.Args = encodeURI(args);
          }
        }
      }
      // 501版本的新验签方式，增加X-BOX-AUTHORIZATION头，内容为签名字符串
      if (hasBoxAuth) {
        const authData =
          this.Method == "GET" ? boxAuthData || {} : boxAuthData || this.Args;
        const key =
          DEVICE == "ios" ? httpApi.newSignKeyIosV3 : httpApi.newSignKeyAdV3;
        this.Request.setRequestHeader(
          "X-BOX-AUTHORIZATION",
          await createBoxAuthorizationFromRequest({
            secretKey: key,
            config: boxAuthRequestConfig,
            data: authData,
            signObj: signObj,
          }),
        );
      }
      try {
        this.Request.send(this.Args);
      } catch (e) {
        console.log("connect exception.");
      }
    });
  };

  function _onStateChange(xhr, success, failure) {
    if (xhr.readyState == 4) {
      var s = xhr.status;
      if (s == 0) {
        console.log("connect to url failure.");
      } else if (s >= 200 && s < 400) {
        success(xhr);
      } else {
        failure(xhr);
      }
    }
  }
}

class http {
  constructor() {}

  originPost(obj, fn) {
    if (obj.json !== undefined) {
      AjaxJson(obj.url, "post", obj.json, fn, "json");
    } else {
      AjaxJson(obj.url, "post", obj.data, fn);
    }
  }
  originGet(obj, fn) {
    if (obj.json !== undefined) {
      AjaxJson(obj.url, "get", obj.json, fn, "json");
    } else {
      AjaxJson(obj.url, "get", obj.data, fn);
    }
  }
  wrongCodeTest() {
    // try {
    // 	if (data.code == 400) {
    // 	}
    // } catch (err) {
    // 	console.log(err)
    // }
  }
  httpPost(obj) {
    return new Promise((resolve) => {
      this.originPost(obj, (res) => {
        resolve(res);
      });
    });
  }
  httpGet(obj) {
    return new Promise((resolve) => {
      this.originGet(obj, (res) => {
        this.wrongCodeTest(res);
        resolve(res);
      });
    });
  }
  msgPost(obj) {
    return new Promise((resolve) => {
      this.originPost(obj, (res) => {
        this.wrongCodeTest(res);
        if (res.code == 200) {
          resolve(res.data);
        } else {
          // _Msg.error(res.msg)
        }
      });
    });
  }
  usualPost(obj) {
    return new Promise((resolve, reject) => {
      this.originPost(obj, (res) => {
        this.wrongCodeTest(res);
        if (res.code == 200) {
          resolve(res.data);
        } else {
          reject(res);
        }
      });
    });
  }
}

export default new http();
